import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TypedForm } from '@models/support/interfaces';
import { ISourceItemData } from '@se/models';

export interface IDeleteExamDialogDataProps {
    message: string;
    body?: string;
    cancelLabel?: string;
    confirmLabel?: string;
    panelClass?: string;
    confirmOnEnter?: boolean;
    deletingReasonItems: ISourceItemData[];
    isDeletingReasonEnabled: boolean;
}

@Component({
    selector: 'se-delete-exam-dialog',
    templateUrl: './delete-exam-dialog.component.html',
    styleUrls: ['./delete-exam-dialog.component.scss'],
    standalone: false
})
export class DeleteExamDialogComponent implements OnInit {
    confirmLabel = 'Yes';
    cancelLabel = 'No';

    form: FormGroup<TypedForm<Record<string, string>>> | null = null;

    constructor(
        private dialogRef: MatDialogRef<IDeleteExamDialogDataProps, string | null>,
        @Inject(MAT_DIALOG_DATA) public data: IDeleteExamDialogDataProps,
    ) {
        this.confirmLabel = this.data.confirmLabel ?? this.confirmLabel;
        this.cancelLabel = this.data.cancelLabel ?? this.cancelLabel;
    }

    ngOnInit(): void {
        this.form = new FormGroup<TypedForm<Record<string, string>>>({
            deletingReason: new FormControl<string>('', {
                nonNullable: true,
                validators: this.data.isDeletingReasonEnabled ? [Validators.required] : [],
            }),
        });

        const classesToAdd: string[] = ['se-delete-exam-dialog'];
        if (this.data.panelClass) classesToAdd.push(this.data.panelClass);
        this.dialogRef.addPanelClass(classesToAdd);
    }

    confirm() {
        if (this.form && this.form.valid) this.dialogRef.close(this.form.get('deletingReason')?.value ?? '');
    }

    closeDialog() {
        this.dialogRef.close(null);
    }
}
